import get from 'lodash/get'

import { fetchCollection } from './index'

import { technicianServicingVersionsSchema } from '../schemas'

export const TECHNICIAN_SERVICING_VERSIONS_REQUEST = 'TECHNICIAN_SERVICING_VERSIONS_REQUEST'
export const TECHNICIAN_SERVICING_VERSIONS_SUCCESS = 'TECHNICIAN_SERVICING_VERSIONS_SUCCESS'
export const TECHNICIAN_SERVICING_VERSIONS_FAILURE = 'TECHNICIAN_SERVICING_VERSIONS_FAILURE'

export function fetchTechnicianServicingVersionsForLocationInContract (locationId, query) {
  return fetchCollection({
    url: `/locations/${locationId}/technician_servicing_versions`,
    query,
    key: 'technicianServicingVersions',
    schema: technicianServicingVersionsSchema,
    actions: [
      TECHNICIAN_SERVICING_VERSIONS_REQUEST,
      TECHNICIAN_SERVICING_VERSIONS_SUCCESS,
      TECHNICIAN_SERVICING_VERSIONS_FAILURE
    ],
    responseInterceptor: (response) => ({ ...response, locationId })
  })
}

export function loadTechnicianServicingVersionsForLocationInContract (locationId) {
  return (dispatch, getState) => {
    let {
      contractId,
      datePeriod: {
        startPeriod,
        endPeriod
      } = {}
    } = get(getState(), `workTrackerFilters.${locationId}`, {})

    if (startPeriod) { startPeriod = startPeriod.toISOString() }
    if (endPeriod) { endPeriod = endPeriod.toISOString() }

    return dispatch(fetchTechnicianServicingVersionsForLocationInContract(locationId, { contractId, startPeriod, endPeriod }))
  }
}



// WEBPACK FOOTER //
// ./src/actions/technician-servicing-versions.js